//BookClub.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faBook, faBookOpen, faGifts, faHandsHelping, faRainbow, faShoppingCart, faVideo, faClock, faChartLine, faCalendarAlt, faCloud, faExclamationTriangle, faUserShield, faBuilding, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import './styles/BookClub.css';
import './styles/BookShelfListComponent.css';

import bookclubimage from '../../assets/pageimages/BookClub.webp';

function BookClubHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>BookClub</h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/bookclub-list" className="top-button-link"><FontAwesomeIcon icon={faGlobe} className="bookclub-bottomlink-style" />Think5Whys Book Clubs</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookclub-members" className="top-button-link"><FontAwesomeIcon icon={faGlobe} className="bookclub-bottomlink-style" />My Digital Book Clubs</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookclub-membership" className="top-button-link"><FontAwesomeIcon icon={faGlobe} className="bookclub-bottomlink-style" />Members</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookclub-create" className="top-button-link"><FontAwesomeIcon icon={faGlobe} className="bookclub-bottomlink-style" />Create Club</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="bookclub-id" src={bookclubimage} alt="BookClub Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default BookClubHome;
